import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Loader2, ArrowLeft, MailCheck } from 'lucide-react';
import { supabase } from '../lib/supabaseClient';
import { LogoMark, Wordmark } from '../components/Logo';
import ThemeToggle from '../components/ThemeToggle';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: `${window.location.origin}/reset-kata-laluan`,
    });
    setLoading(false);
    if (error) { toast.error('Gagal menghantar emel. Coba lagi.'); return; }
    setSent(true);
    toast.success('Emel set semula dihantar (jika akaun wujud).');
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="flex items-center px-6 h-16 bg-card border-b border-border">
        <Link to="/masuk" className="flex items-center gap-2"><LogoMark size={34} /><Wordmark size="text-lg" /></Link>
        <div className="ml-auto"><ThemeToggle /></div>
      </header>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8">
          {sent ? (
            <div className="text-center" data-testid="reset-sent">
              <div className="mx-auto h-14 w-14 rounded-2xl bg-emerald2-light flex items-center justify-center mb-4">
                <MailCheck className="h-7 w-7 text-emerald2" />
              </div>
              <h1 className="text-2xl font-bold text-foreground">Semak emel anda</h1>
              <p className="mt-2 text-muted-foreground">Kami telah menghantar pautan set semula kata laluan ke <b>{email}</b> jika akaun wujud.</p>
              <Link to="/masuk"><Button variant="outline" className="mt-6 h-11">{t('kembali')}</Button></Link>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-bold text-foreground">{t('lupaKataLaluan')}</h1>
              <p className="mt-2 text-muted-foreground">Masukkan emel anda, kami akan hantar pautan set semula.</p>
              <form onSubmit={submit} className="mt-6 space-y-5" data-testid="forgot-form">
                <div className="space-y-2">
                  <Label htmlFor="email">{t('emel')}</Label>
                  <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12" data-testid="forgot-email" />
                </div>
                <Button type="submit" disabled={loading} className="w-full h-12 bg-brand text-white hover:bg-brand-royal" data-testid="forgot-submit">
                  {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : t('hantar')}
                </Button>
              </form>
              <Link to="/masuk" className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-brand hover:underline">
                <ArrowLeft className="h-4 w-4" />{t('kembali')}
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
